module.exports = __webpack_public_path__ + "static/media/co2.d6e2de87.jpg";